<template>
	<div>
		<a-button
			type="primary"
			class="primary"
			size="small"
			@click="showNodetrace"
		>
			{{ $t('businessDispatch.customsInfo') }}
		</a-button>
		<a-modal
			:title="$t('businessDispatch.customsInfo')"
			:visible="visible_nodetrace"
			:confirm-loading="confirmLoading_node"
			@cancel="cancelNodetrace"
			width="500px"
		>
			<template>
				<a-form>
					<a-form-item :label="$t('businessDispatch.billNumber')"> {{ reportData.blNo }} </a-form-item>
					<a-form-item :label="$t('businessDispatch.customsDeclarationTime')">
						<a-radio-group :value="reportData.type.code">
							<a-radio
								value="BEFORE_INGATE"
								:disabled="reportData.type.code == 'AFTER_INGATE'"
								>{{ $t('businessDispatch.beforeEnteringPortCustomsClearance') }}</a-radio
							>
							<a-radio
								value="AFTER_INGATE"
								:disabled="reportData.type.code == 'BEFORE_INGATE'"
								>{{ $t('businessDispatch.afterEnteringPortCustomsClearance') }}</a-radio
							>
						</a-radio-group>
					</a-form-item>
					<a-form-item label="报关备注"> {{ reportData.remark }} </a-form-item>
					<a-form-item label="报关资料" :labelCol="{ span: 12 }">
						<a-button type="primary" @click="fileDownload">{{ $t('download') }}/{{ $t('check') }}</a-button>
						<File-download ref="fileDownloadRef"></File-download>
					</a-form-item>
					<a-form-item label="放行单/报关单" :labelCol="{ span: 12 }">
						<a-button type="primary" @click="fileUpload">{{ $t('upload') }}/{{ $t('check') }}</a-button>
						<File-upload
							ref="fileUploadRef"
							:declarationResult="declarationResult"
						></File-upload>
					</a-form-item>
					<br /><br />
					<a-form-item :label="$t('prompt')" class="prom">
						<div>{{ $t('businessDispatch.customsDeclarationTips') }}</div>
					</a-form-item>
				</a-form>
			</template>

			<template slot="footer" class="footer">
				<a-button key="back" @click="cancelNodetrace">{{ $t('close') }}</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
// 根据提单号获取报关信息
import { getDeclarationByBlNo } from "../../api/business-dispatch";
import FileDownload from "./file-download.vue";
import FileUpload from "./file-upload.vue";
import { searchReqParam } from "../../utils/searchReqParam";

export default {
	name: "port-report",
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	components: { FileDownload, FileUpload },
	data() {
		return {
			req: searchReqParam(),
			visible_nodetrace: false,
			confirmLoading_node: false,
			reportData: {
				blNo: "",
				remark: "",
				type: {
					code: "",
					value: "",
				},
			},
			declarationResult: {},
		};
	},
	computed: {},
	mounted() {},
	methods: {
		async showNodetrace() {
			if (this.selectedRows.length >= 1) {
				console.log(this.selectedRows[0], this.req);
				if (!this.selectedRows[0].isDeclaration) {
					return this.$message.warn(this.$t('businessDispatch.noNeedEntrustTips'));
				}
				this.req.params.blNo = this.selectedRows[0].blNumber;
				await getDeclarationByBlNo(this.req)
					.then((res) => {
						console.log(res);
						let result = JSON.parse(res.data);
						console.log(result);
						this.declarationResult = result.data;
						if (!result.success || result.code !== "0") {
							this.$message.error(result.msg);
							return;
						}
						if (
							result.data.blNo == null &&
							this.selectedRows[0].isDeclaration
						) {
							this.$message.warn(this.$t('businessDispatch.noCustomsClearanceInfoTips'));
							return;
						}
						if (
							result.data.blNo == null &&
							this.selectedRows[0].isDeclaration == false
						) {
							this.$message.warn(this.$t('businessDispatch.noNeedEntrustTips'));
							return;
						}
						if (this.selectedRows[0].isDeclaration == null) {
							this.$message.warn(this.$t('businessDispatch.noConvoyCustomsClearanceInfoTips'));
							return;
						}
						this.reportData = result.data;
						console.log(this.reportData);
						this.visible_nodetrace = true;
					})
					.catch((err) => {
						this.$message.error(err);
					});
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'));
			}
		},
		cancelNodetrace() {
			this.visible_nodetrace = false;
		},
		// 下载报关资料
		fileDownload() {
			// this.$refs["fileDownloadRef"].visibleAttach = true;
			let target = JSON.parse(JSON.stringify(this.selectedRows[0]));
			target.containerId = this.reportData.id;
			this.$refs["fileDownloadRef"].showAttachment({
				attach: target,
			});
		},
		// 上传报关资料
		fileUpload() {
			let target = JSON.parse(JSON.stringify(this.selectedRows[0]));
			target.containerId = this.reportData.id;
			this.$refs["fileUploadRef"].showUploadAttachment({
				attach: target,
			});
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
	text-align: left;

	.ant-form-item-label {
		text-align: left;
	}
	.ant-form-item-control-wrapper {
		display: inline-block;
	}
}

/deep/ .prom {
	.ant-form-item-control-wrapper {
		display: block;
	}
}
</style>
